<input
  #inputEl
  type="checkbox"
  id="switch"
  data-testid="input-tab"
  [(ngModel)]="isChecked"
  (change)="onChange(inputEl.checked)" />

<div class="content flex flex-column text-center {{ classDiv }}">
  <label
    for="switch"
    class="label-switch h-45px w-100 relative background-app-aside-nav-head-bg">
    <div class="toggle h-45px absolute w-50 background-purple-tabs"></div>
    <div class="names absolute ml-0 flex align-items-center w-100">
      <p
        class="f14 fw-normal w-50 text-center"
        [ngClass]="{ white: !isChecked, 'color-psr-text-color': isChecked }">
        {{ text1 }}
      </p>
      <p
        class="f14 fw-normal w-50 text-center"
        [ngClass]="{ white: isChecked, 'color-psr-text-color': !isChecked }">
        {{ text2 }}
      </p>
    </div>
  </label>
</div>
